import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ooredooDCBPaymentStatus } from "../../../Utilities/controller"
import { toast } from "react-toastify";

const OoredooOtpPopup = (props) => {

    const [otp, setOtp] = useState('');

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        if (otp.length === 6) { // Assuming OTP is 6 digits

            /** set opt modal false and set loading true */
            props.setLoading(true);

            // Call the function to continue
            const paymentRes = await ooredooDCBPaymentStatus({...props.ooredooDCBAuthToken, "otpValue": otp});

            console.log("paymentRespaymentRespaymentRes---------------->",paymentRes);
            if(paymentRes && paymentRes?.data?.success) {
                setOtp('');
                props.setShowOtpModel(false);
                props.setLoading(false);
                window.location.href = paymentRes?.data?.data ;
            } else {
                toast.error("Please enter a valid OTP");
                props.setShowOtpModel(true);
                props.setLoading(false);
            }
        } else {
            toast.error("Please enter a valid OTP");
        }
    };

    const handleClose = () => {
        props.setShowOtpModel(false);
    };

    return (
        <>
            <Modal
                show={props.showOtpModel}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="winningBreakupModal modal fade"
                centered
            >
                <Modal.Body>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                        {props.isRecurring && <h5>This is a Recurring payment, Your payment will be automatically charged at regular intervals.</h5>}
                        <h3>Please enter the otp to proceed.</h3>
                        <Form onSubmit={handleSubmit} style={{width: "500px"}}>
                            <Form.Group controlId="formOtp">
                                <Form.Control
                                    type="text"
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={handleOtpChange}
                                    maxLength={6} // Assuming OTP is 6 digits
                                    autoFocus
                                />
                            </Form.Group>
                            <div className="d-flex justify-content-evenly" style={{marginTop: "25px"}}>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button variant="primary" type="submit">
                                    Continue
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default OoredooOtpPopup;
